import TraitsListCollapser from './TraitsListCollapser'

export default TraitsListCollapser
